const questions = [
    {
        question: `¿PARA REGISTRARME ES NECESARIO COMPRAR COMO CLIENTE? `,
        answer: `No, puede registrarse y navegar en nuestra tienda, sin la necesidad de comprar. Si usted quiere comprar, sí es necesario registrarse.`,
    },
    {
        question: `¿CÓMO ME ENTERO SI ES ACEPTADO MI REGISTRO DE DATOS Y SI MI ORDEN FUE ACEPTADA?`,
        answer: `Le enviaremos vía e-mail un correo automático para informarle de su registro y de la orden de compra que confirmó usted. En los pedidos realizados por teléfono, en forma inmediata le notificaremos el número de su orden. Así mismo se puede apoyar con nuestros asesores de ventas.`,
    },
    {
        question: `¿QUÉ HAGO SI OLVIDÉ MI CLAVE DE ACCESO? `,
        answer: `En la sección de inicio de sesión hay una opción donde puede cambiar su clave "¿Olvidaste tu contraseña?" Solo debe proporcionar la cuenta de email con la que se registró y realizar su cambio de contraseña.`,
    },
    // {
    //     question: `¿CÓMO PUEDO SUBIR DE NIVEL DE USUARIO Y APROVECHAR LOS DESCUENTOS Y PRECIOS ESPECIALES?`,
    //     answer: `Puede pedir asesoramiento con nuestro personal autorizado a nuestro WhatsApp y al correo ventas@diasa.net para negociar su nivel de usuario; también si las compras son frecuentes y sus pagos se realizan a tiempo, podrá obtener descuentos.`,
    // },
    // {
    //     question: `¿QUÉ ES LA COMUNIDAD REDALIADO?`,
    //     answer: `Red Aliado es un programa enfocado para distribuidores locales o foráneos, en el cual obtienen beneficios y descuentos dependiendo de las compras continuas o por volúmenes trimestrales.`,
    // },
    // {
    //     question: `¿QUÉ GARANTÍA TENGO EN LAS REFACCIONES QUE COMPRO CON REDHOGAR?`,
    //     answer: `Usted obtiene garantía en Calidad, Efectividad y Servicio; nuestras refacciones tienen el respaldo de las marcas más reconocidas a nivel nacional e internacional, y su garantía es de fábrica. Los productos que no aplican garantía son las Refacciones Electrónicas.`,
    // },
    // {
    //     question: `¿QUE PASA CUANDO REALIZO MI COMPRAR Y APARACE “SOLICITAR PRODUCTO”?`,
    //     answer: `Esto sucede cuando el stock del producto está en algunas de nuestras sucursales o almacenes locales y esto afectará un poco en el tiempo de entrega (5 a 7 días hábiles) de su pedido.`,
    // },
    {
        question: `¿CÓMO REALIZO LA BÚSQUEDA DE PRODUCTOS?`,
        answer: `Existen varias formas de realziar una búsqueda: 

        A) Introduciendo en el buscador, el código o número de Parte. 
        
        B) Realizando una búsqueda en la sección de búsqueda avanzada. 
        
        C) Buscar mediante el flitro de categorías.`,
    },
    {
        question: `¿TIENEN SUCURSALES FISICAS?`,
        answer: `No, ya que somos distribuidores.`,
    },
    {
        question: `¿EXISTE UN MONTO MÍNIMO DE COMPRA? `,
        answer: `No, no existe. `,
    },
    {
        question: `¿ANTES DE FINALIZAR MI COMPRA, PUEDO SABER QUÉ ES LO QUE HE AGREGADO A MI CARRITO DE COMPRAS Y CUÁL ES EL IMPORTE?`,
        answer: `Sí, en todo momento puede saber el saldo de su orden y su contenido, incluso en el instante de confirmar su pedido.`,
    },
    {
        question: `¿CÓMO PUEDO CONSULTAR MI HISTORIAL Y SABER MIS COMPRAS DE FACTURACIÓN?`,
        answer: `Al ser un usuario registrado podrá visualizar en nuestra plataforma su historial de compras y facturas.`,
    },
    {
        question: `¿ESTÁN SEGUROS MIS DATOS AL REGISTRARLOS?`,
        answer: `Sí, nos preocupamos por proteger la seguridad de la información de todos nuestros clientes, contamos con certificados de seguridad SSL.`,
    },
    {
        question: `¿QUÉ MENSAJERIA USAN SI HAGO UN PEDIDO COMO CLIENTE NORMAL? `,
        answer: `Se hace a través de la mensajería Fedex.`,
    },
    {
        question: `¿CÓMO PODRÉ CONOCER LA GUÍA DE MI PEDIDO SI LO REALICE COMO CLIENTE NORMAL?`,
        answer: `Se le notificará por medio de un correo electrónico por el sistema de Fedex la referencia de guía de su pedido.`,
    },
    {
        question: `¿CÓMO ENVIAN LOS PEDIDOS SI SOY DISTRIBUIDOR? `,
        answer: `Tenemos nuestra propia mensajería.`,
    },
    {
        question: `¿ENTREGAN EN TODA LA REPUBLICA MEXICANA?`,
        answer: `Como cliente normal entregamos en toda la república mexicana a través de nuestra mensajería de Fedex, Como Distribuidor favor de preguntar por nuestra cobertura.`,
    },
    // {
    //     question: `¿CÓMO PUEDO SER DISTRIBUIDOR Y TENER PRECIOS ESPECIALES?`,
    //     answer: `Favor de contactarnos a nuestro WhatsApp al número: o bien al correo ventas@diasa.net`,
    // },
    {
        question: `¿TIENEN GARANTIAS Y DEVOLUCIONES?`,
        answer: `No se aceptan reclamaciones de faltantes o sobrantes de mercancía después de 7 días de recibida, dándose por aceptado el monto total de la factura a pagar, Toda aclaración o faltante favor de reportarlo. Favor de revisarlo con su vendedor`,
    },
    {
        question: `¿LOS PRECIOS INCLUYEN IVA?`,
        answer: `Si todos nuestros precios incluyen IVA.`,
    },
];

export {
    questions as default,
}